import { useEffect } from 'react';

interface Props {
  getDataHandler: () => Promise<void>;
  initTab: () => void;
  getUserAccessRightsHandler: () => Promise<void>;
}
export const useEditUserEffects = ({
  getDataHandler,
  initTab,
  getUserAccessRightsHandler,
}: Props) => {
  useEffect(() => {
    getDataHandler();
  }, [getDataHandler]);

  useEffect(() => {
    initTab();
  }, [initTab]);

  useEffect(() => {
    getUserAccessRightsHandler();
  }, [getUserAccessRightsHandler]);
};
